import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import DatePicker from 'react-datepicker';
import DocumentUpload from '../DocumentUpload';
import RateInput from '../common/RateInput';
import { formatCurrency } from '../../numberUtils';

class EditLineItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: window.moment(props.date).toDate(),
      description: props.description,
      optional_id: props.optional_id,
      hours: props.hours,
      minutes: props.minutes,
      total: props.total,
      maxDate: window.moment(props.endDate).toDate(),
      minDate: window.moment(props.startDate).toDate(),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCurrencyInputChange = this.handleCurrencyInputChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  handleInputChange(key, value) {
    const { rate } = this.props;
    if (key === 'hours' || key === 'minutes') {
      const val = parseInt(value, 10) || 0;
      this.setState({ [key]: val });
      let total;
      const { hours, minutes } = this.state;
      if (key === 'hours') {
        total = (val + (minutes / 60)) * rate;
      } else {
        total = (hours + (val / 60)) * rate;
      }
      this.setState({ total });
    } else {
      this.setState({ [key]: value });
    }
  }

  handleOnBlur(key) {
    const { id, updateLineItem } = this.props;
    const { total } = this.state;
    const value = this.state[key];
    if (key === 'hours' || key === 'minutes') {
      updateLineItem(id, { [key]: value, total });
    } else if (key === 'total') {
      updateLineItem(id, { total: +value });
    } else {
      updateLineItem(id, { [key]: value });
    }
  }

  handleCurrencyInputChange(value) {
    this.setState({ total: +value });
  }

  render() {
    const {
      index,
      invoiceId,
      id,
      hasDuration,
      viewDocumentUrl,
      category,
      deleteLineItem,
      document,
      uploadFile,
      csrfToken,
      status,
      feedback,
    } = this.props;
    const {
      date, minDate, maxDate, description, hours, minutes, total, optional_id,
    } = this.state;
    return (
      <div className={`line-item line-item-edit ${index % 2 === 1 && 'even-row'}`}>
        <div className="g-row--always">
          {feedback && <i className="edits-requested-indicator fa fa-circle" />}
          <div className={`date ${feedback ? 'with-feedback' : ''} g-row g-row--start-between`}>
            <label className="g-row--always" htmlFor={`calendar-${id}`}>
              <DatePicker
                selected={date}
                onChange={(val) => this.handleInputChange('date', val)}
                onBlur={() => this.handleOnBlur('date')}
                minDate={minDate}
                maxDate={maxDate}
                allowSameDay
                className="form-control"
                id={`calendar-${id}`}
                value={date}
                dateFormat="MM/dd/yyyy"
                popperPlacement="top-end"
              />
              <i className="fa fa-calendar" />
            </label>
          </div>
          <div className="optional-id">
            <input
              type="text"
              className="form-control optional-id"
              name="optional-id"
              id="optional-id"
              value={optional_id}
              onChange={(e) => this.handleInputChange('optional_id', e.target.value)}
              onBlur={() => this.handleOnBlur('optional_id')}
            />
          </div>
          <div className="description">
            <TextareaAutosize
              name="description"
              className="fs-hide description"
              placeholder="Describe what you worked on here..."
              value={description}
              onChange={(e) => this.handleInputChange('description', e.target.value)}
              onBlur={() => this.handleOnBlur('description')}
              rows={1}
            />
          </div>
          {hasDuration
            && (
            <div className="hours-and-minutes g-row--always g-row--start">
              <input
                type="number"
                id={`hours-${id}`}
                className="form-control hours"
                min="0"
                value={hours !== 0 ? hours : ''}
                onChange={(e) => this.handleInputChange('hours', parseInt(e.target.value, 10))}
                onBlur={() => this.handleOnBlur('hours')}
              />
              <div className="body-text-2 mx-2 mt-2">h</div>
              <input
                type="number"
                id={`minutes-${id}`}
                className="form-control minutes"
                min="0"
                max="60"
                value={minutes !== 0 ? minutes : ''}
                onChange={(e) => this.handleInputChange('minutes', e.target.value, 10)}
                onBlur={() => this.handleOnBlur('minutes')}
              />
              <div className="body-text-2 ms-2 mt-2">min</div>
            </div>
            )}
          {hasDuration
            ? (
              <div className="total">
                {formatCurrency(total)}
              </div>
            )
            : (
              <div className="total">
                <RateInput
                  className="form-control total"
                  value={total}
                  onAnswerChange={(val) => this.handleCurrencyInputChange(val)}
                  onBlur={() => this.handleOnBlur('total')}
                />
              </div>
            )}
          {!hasDuration
            && (
            <div className="file">
              <DocumentUpload
                prompt="Add File"
                viewDocumentUrl={viewDocumentUrl}
                csrfToken={csrfToken}
                documentType="invoice"
                location="Invoicing"
                uploadDocumentUrl={`/invoices/${invoiceId}/line_items/upload_file?id=${id}`}
                handleAfterUpload={(doc) => uploadFile(id, doc)}
                document={document}
              />
            </div>
            )}
          <div className="actions">
            <button
              className="delete"
              onClick={() => deleteLineItem(id, category)}
            >
              <i className="fa fa-trash-alt mt-6" />
            </button>
          </div>
        </div>
        {status === 'edits_requested' && feedback
          && (
          <div className="line-item-feedback">
            <div className="body-text-2 medium-weight pb-8">Comments</div>
            <div className="body-text-2">{feedback}</div>
          </div>
          )}
      </div>
    );
  }
}

EditLineItem.propTypes = {
  id: PropTypes.number,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  updateLineItem: PropTypes.func.isRequired,
  hasDuration: PropTypes.bool,
  rate: PropTypes.number,
  invoiceId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  viewDocumentUrl: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  deleteLineItem: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  document: PropTypes.shape({}),
  uploadFile: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  csrfToken: PropTypes.string,
  status: PropTypes.string.isRequired,
  feedback: PropTypes.string,
  optional_id: PropTypes.string,
};

EditLineItem.defaultProps = {
  id: null,
  hasDuration: false,
  rate: null,
  csrfToken: '',
  document: {},
  feedback: '',
  optional_id: '',
};

export default EditLineItem;
